import { DatoImage } from '@/elements/global/DatoImage'
import Link from 'next/link'
import styled from 'styled-components'

type ArticleCardProps = {
  article: {
    id?: number
    _firstPublishedAt?: string
    articleSlug?: string
    articleTitle?: string
    abstract: string
    featuredImage: {
      responsiveImage?: {
        alt?: string
        aspectRatio?: number
        base64?: string
        bgColor?: string
        height?: number
        sizes?: string
        src?: string
        srcSet?: string
        title?: string
        webpSrcSet?: string
        width?: number
      }[]
    }
    square: {
      responsiveImage?: {
        alt?: string
        aspectRatio?: number
        base64?: string
        bgColor?: string
        height?: number
        sizes?: string
        src?: string
        srcSet?: string
        title?: string
        webpSrcSet?: string
        width?: number
      }[]
    }
  }
  className?: string
  firstFeatured?: boolean
}

const StyledArticleCard = styled.div`
  text-align: left;
  a {
    color: ${(props) => props.theme.v2.onSurface.text};
  }
  p {
    margin: 12px 0 0;
    padding: 0;
  }
  h3 {
    margin: 12px 0 0;
  }
  img {
    border-radius: 8px;
    object-fit: cover;
  }
`
export const ArticleCard = ({ article, className, firstFeatured }: ArticleCardProps) => {
  return (
    <StyledArticleCard className={className}>
      <Link href={`/learn/${article.articleSlug}`} passHref>
        {!firstFeatured ? (
          <DatoImage data={article.featuredImage.responsiveImage} />
        ) : (
          <>
            <DatoImage data={article.square.responsiveImage} className="desktop" />
            <DatoImage data={article.featuredImage.responsiveImage} className="mobile" />
          </>
        )}
        <h3>{article.articleTitle}</h3>
        {firstFeatured ? (
          <p className="small secondary">{article.abstract.split(' ').splice(0, 30).join(' ')}...</p>
        ) : (
          <p className="small secondary">{article.abstract.split(' ').splice(0, 12).join(' ')}...</p>
        )}
      </Link>
    </StyledArticleCard>
  )
}
